/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQueryWorkloadType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("WorkloadQueryWorkloadType");
    }

    getFixupPrototypeFunction() { return WorkloadQueryWorkloadType.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQueryWorkloadType>): WorkloadQueryWorkloadType {
        let obj = Object.assign(new WorkloadQueryWorkloadType(), model);
        WorkloadQueryWorkloadType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQueryWorkloadType>): WorkloadQueryWorkloadType {
        if (!model) return null;
        return WorkloadQueryWorkloadType.newInstance(<WorkloadQueryWorkloadType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQueryWorkloadType) {
        if (!obj) return;

        models.WorkloadQueryWorkloadType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQueryWorkloadType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadQueryWorkloadType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of the Workload
     */
    workload_types: Array<string>;

}
